import React, { useEffect, useState, useRef } from "react";
import SoftBox from "components/SoftBox";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import Loading from "components/ApnaLoading";
import PropTypes from "prop-types";
import GetAddressDetails from "api/addressFunction";
import useMediaQuery from "@mui/material/useMediaQuery";

const SelectLocation = ({
  lat,
  lng,
  setValues,
  setAddressData,
  fetchApi,
  disabled,
  height = "50vh",
}) => {
  
  const matches = useMediaQuery("(max-width:600px)");
  const [location, setLocation] = useState({ lat: 0, lng: 0 });
  const [showMap, setShowMap] = useState(false);
  const [map, setMap] = useState(null);

  // Map container styles
  const containerStyle = {
    height: matches ? "30vh" : height,
    width: "100%",
    borderRadius: "20px",
  };

  useEffect(() => {
    if (lat && lng) {
      setLocation({ lat, lng });
      setShowMap(true);
    }
  }, [lat, lng]);

  const onMapLoad = (mapInstance) => {
    setMap(mapInstance);
    if (lat && lng) {
      mapInstance.panTo({ lat, lng });
    }
  };

  const onMapClick = async (event) => {
    if (disabled) return;

    const newLat = event.latLng.lat();
    const newLng = event.latLng.lng();

    setLocation({ lat: newLat, lng: newLng });

    if (fetchApi) {
      const address = await GetAddressDetails(newLat, newLng);
      setAddressData(address);
      console.log("Address data:", address);
    }

    setValues((prev) => ({
      ...prev,
      latitude: newLat,
      longitude: newLng,
    }));
  };

  return (
    <>
      {showMap ? (
        <SoftBox sx={{ borderRadius: "20px" }}>
          {/* <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            libraries={["places"]}
          > */}
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={location}
              zoom={12}
              onLoad={onMapLoad}
              onClick={onMapClick}
              options={{
                zoomControl: true,
                scaleControl: true,
                rotateControl: true,
                draggable: true,
                disableDoubleClickZoom: true,
                scrollwheel: true,
                gestureHandling: "auto",
              }}
            >
              <Marker position={location} />
            </GoogleMap>
          {/* </LoadScript> */}
        </SoftBox>
      ) : (
        <Loading />
      )}
    </>
  );
};

SelectLocation.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  setValues: PropTypes.func.isRequired,
  setAddressData: PropTypes.func,
  fetchApi: PropTypes.bool,
  disabled: PropTypes.bool,
  height: PropTypes.string,
};

export default SelectLocation;
